<script>
import { Compact } from 'vue-color'
import LABELS from "@/constants/labels";
export default {
  components: {
    'compact-picker': Compact,
  },
  data: () => ({
    open: false,
    index: '',
    value: '#000000',
  }),
  props: {
    palette: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    mappingLabels() {
      return LABELS;
    }
  },

  methods: {
    onChangeColor(color) {
      this.$emit('on-change', color.hex, this.index)
    },
    show(color, idx = '') {
      this.value = color
      this.index = idx
      this.open = true
    },

    hide() {
      this.open = false
      this.$emit('hide')
    },
  },
}
</script>

<template>
  <s-modal :show="open">
    <div class="modal-avatar-color" v-if="open">
      <div class="modal-avatar-color__close" @click="hide">
        <x-icon-close />
      </div>
      <div class="modal-avatar-title">
        {{ mappingLabels.colorSelectText }}
      </div>
      <compact-picker
        :value="value"
        @input="onChangeColor"
        :palette="palette"
        class="compact-picker"
      ></compact-picker>
      <div class="modal-avatar-color__btn">
        <button
          class="s-button grey-4-btn close-btn modal-avatar-color_btn"
          @click="hide"
        >
          閉じる
        </button>
      </div>
    </div>
  </s-modal>
</template>

<style lang="scss" scoped>
@import './modal-avatar-color.scss';
</style>
